import React from 'react';

const About = () => {
    return (
        <div style={{height:'100%', width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'150px'}}>
            About page is under Development
        </div>
    );
}

export default About;
